var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtpName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "767 483 17.615 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #868686;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(993.4 535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "cls-1",
    d: "M0,18.333A1.685,1.685,0,0,0,1.692,20H15.923a1.685,1.685,0,0,0,1.692-1.667,7.9,7.9,0,0,0-7.949-7.82H7.923A7.89,7.89,0,0,0,0,18.333Z",
    transform: "translate(-226.4 -52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-1",
    d: "M12.692,5.359V3.9a3.872,3.872,0,1,0-7.744-.026V5.333a3.872,3.872,0,1,0,7.744.026Z",
    transform: "translate(-226.4 -52)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpName);
export default __webpack_public_path__ + "static/media/otp_name.942cb69d88955703a18254b8c91cdc93.svg";
export { ForwardRef as ReactComponent };